<template>
    <div ref="videoParent" class="embed__video embed-container" :class="videoInfo.aspect_ratio ? `embed-container--${videoInfo.aspect_ratio}` : `embed-container--square`">
        <iframe v-if="src !== ''" ref="video" :src="`${src}&color=6fafad&vimeo_logo=0&title=0&byline=0pip=0`"
            allow="autoplay; fullscreen; encrypted-media; autopause; playsinline;" allowfullscreen="" width="500"
            height="281" frameborder="0" :data-is-valid="isValid === true ? 'true' : 'false'">
        </iframe>
        <div class="embed__loader r fadelogo fadelogo--active">
            <Icon name="sp/spinepal-logomark" />
        </div>
    </div>
</template>

<script>
import Icon from "@c/Icon.vue";
export default {
    components: {
        Icon,
    },
    data() {
        return {
            watched: false,
            isValid: false,
            player: null,
        }
    },
    props: {
        videoInfo: Object,
        activeVideo: Number,
        id: Number,
        appState: String,
        instance: Object,
        pauseVideo: Boolean,
        active: Boolean,
    },
    computed: {
        src() {
            // This is how the url should look in the end
            // https://player.vimeo.com/video/742345068?h=fc79be6ce6&amp;dnt=1&amp;app_id=122963
            // oEmbed sdk: https://developer.vimeo.com/api/oembed/videos

            if (this.videoInfo.embed_url === null | this.videoInfo.embed_url === undefined) { return ""; }

            let url = this.videoInfo.embed_url;
            var match = url.split("/");

            if (match) {
                return `https://player.vimeo.com/video/${match[3]}?h=${match[4]}&dnt=1&app_id=122963&pip=false&autopause=true&width=500&height=281&maxwidth=600&dnt=true&responsive=true`;
            } else {
                return "";
            }
        },
    },
    watch: {
        appState() {
            if (this.appState === "home" || this.appState === "topic") {
                this.reset();
            }
        },
        pauseVideo() {
            // When we are told to pause the video by the parent component, just do it
            if (this.pauseVideo === true) {
                this.pause();
            }
        },
        active() {
            // When this comes active, start everything back up from default
            if (this.active === true) {
                console.log('VIDEO PLAYER: Active');
                this.reset();
                this.init();
                this.validate();
            } else {
                this.pause();
            }
        },
        activeVideo(newValue) {
            if (newValue !== this.id) {
                this.pause();
            }
        }
    },
    mounted() {
        this.reset();
        this.init();
        this.validate();
    },
    destroyed() {
        this.reset();
    },
    methods: {
        finish() {
            this.player.pause();
            this.player.unload(); // set the video back to initial state
            this.watched = false;
            this.isValid = false;
            this.$emit('close');
        },
        // Button click to pause
        pause() {
            if (this.player === null) { return; }
            this.watched = false;
            this.isValid = false;
            this.player.pause();
            this.player.unload(); // set the video back to initial state
        },
        // Validate if it's required
        validate() {
            if (this.instance.required === true) {
                if (this.watched === true) {
                    this.isValid = true;
                } else {
                    this.isValid = false;
                }
            } else {
                this.isValid = true;
            }
            this.$nextTick(() => {
                this.$emit('validate');
            });
        },
        // What to do when we play the video
        playing() {
            console.log('VIDEO PLAYER: playing video');
            // Tell parent we are playing a video
            this.$emit('playingVideo', this.id);

            if (this.watched === false) {
                this.watched = true;
                // Fire watched event
                this.postVideoWatched();
            }

            this.validate();
        },
        // Load video player
        init() {
            console.log('VIDEO PLAYER: Init');
            this.player = new Vimeo.Player(this.$refs.video);
            this.player.on('play', this.playing);
        },
        // Resets player to default
        reset() {
            console.log('VIDEO PLAYER: Reset');
            this.pause();
            if (this.player !== null) {
                this.player.off('play', this.playing);
                this.player = null;
            }
            this.watched = false;
            this.isValid = false;
        },
        postVideoWatched() {
            console.log('VIDEO PLAYER: Posting video watched');
            let event_title = this.videoInfo.title ? `${this.videoInfo.title} (${this.videoInfo.embed_url})` : `${this.videoInfo.embed_url}`;
            let data = {
                type: 'watched',
                title: event_title,
            };
            window.events.postAction(data);
        },
    },
}
</script>

<style lang="scss"></style>